import React from 'react';
import PropTypes from 'prop-types';
import { Table, Header } from 'semantic-ui-react';
import LocationListRow from './LocationContactListRow';

const LocationContactList = props => {
  const { auctionLocationList, onSelectAuctionLocation, isAuctionLocationEditor } = props;
  const listRow = LocationListRow(onSelectAuctionLocation, isAuctionLocationEditor);

  const headerRow = (
    <Table.Row className='all-contact-ext-table'>
      <Table.HeaderCell>Auction Name</Table.HeaderCell>
      <Table.HeaderCell>Contact Name</Table.HeaderCell>
      <Table.HeaderCell>Title</Table.HeaderCell>
      <Table.HeaderCell>Email</Table.HeaderCell>
      <Table.HeaderCell>Phone</Table.HeaderCell>
      <Table.HeaderCell>Contact Type</Table.HeaderCell>
      <Table.HeaderCell>Guarantee Confirm</Table.HeaderCell>
      <Table.HeaderCell>Guarantee Cancel</Table.HeaderCell>
      <Table.HeaderCell>Returns</Table.HeaderCell>
      <Table.HeaderCell>Veh not covered</Table.HeaderCell>
      <Table.HeaderCell />
    </Table.Row>
  );

  return (
    <div>
      <Header>All Auction Contacts</Header>
      <div>
        <Table
          celled
          selectable
          padded
          renderBodyRow={listRow}
          tableData={auctionLocationList}
          headerRow={headerRow}
          size='small'
          compact='very'
          style={{ fontSize: '90%' }}
          striped
          className='all-contact-ext-table'
        />
      </div>
    </div>
  );
};

LocationContactList.propTypes = {
  auctionLocationList: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelectAuctionLocation: PropTypes.func.isRequired,
  isAuctionLocationEditor: PropTypes.bool.isRequired,
};

export default LocationContactList;
